import React from 'react';

import { Image, Button } from 'react-bootstrap';

import { FullScreenModal } from 'components/shared/FullScreenModal/FullScreenModal';
import { Trans, useTranslation } from 'react-i18next';

import './style.scss';

export const LoginLanding = () => {
    const {t} = useTranslation();

    return (
        <FullScreenModal close={false}>
            <div className="LoginLanding__logoDiv">
                <Image src="/assets/images/DSP-Logo.svg" className="Registration__logo"/>
            </div>
            <div className="LoginLanding__description">
                <p className="LoginLanding__description-text text-center">
                    <Trans i18nKey="loginLanding.description">
                        Welcome to the Disability Skills Passport program! Please login as either an individual or a
                        company.
                    </Trans>
                </p>
            </div>
            <div className="LoginLanding__buttons">
                {/*individual sso login*/}
                <Button
                    href={(window as any).ENV.REACT_APP_DSP_LOGIN}
                    variant="primary"
                    className="btn-xl LoginLanding__button mb-2"
                >
                    {t('loginLanding.actions.loginAsIndividual', 'LOGIN AS AN INDIVIDUAL')}
                </Button>
                {/*company sso login*/}
                <Button
                    href={(window as any).ENV.REACT_APP_DSP_COMPANY_LOGIN}
                    variant="info"
                    className="btn-xl LoginLanding__button mb-5"
                >
                    {t('loginLanding.actions.loginAsCompany', 'LOGIN AS A COMPANY')}
                </Button>
                <Button
                    href={(window as any).ENV.REACT_APP_DSP_PORTAL_HOME}
                    variant="light"
                    className="btn-xl LoginLanding__button mb-5"
                >
                    {t('loginLanding.actions.returnHome', 'RETURN HOME')}
                </Button>
            </div>
        </FullScreenModal>
    );
};
